/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import BaseObject from "@shared/BaseObject.js";

export default class QwoachFileMetadataManager extends BaseObject {

	constructor() {
		super();
		this.unsplashImageLoadListener = null
		this.mountedFile = null
		this.mountedView = null
	}

	mount(qwoachFile, view) {
		this.unmountCurrent()
		this.setMountedContext(qwoachFile, view)
		this.mountMetadataBranches(qwoachFile, view)
	}

	unmount(qwoachFile, view) {
		let mountedFile = qwoachFile || this.mountedFile
		let mountedView = view || this.mountedView
		this.unmountMetadataBranches(mountedFile, mountedView)
		this.clearMountedContext()
	}

	unmountCurrent() {
		this.unmount(this.mountedFile, this.mountedView)
	}

	setMountedContext(qwoachFile, view) {
		this.mountedFile = qwoachFile || null
		this.mountedView = view || null
	}

	clearMountedContext() {
		this.mountedFile = null
		this.mountedView = null
	}

	mountMetadataBranches(qwoachFile, view) {
		this.mountSourceDescriptionMetadataBranch(qwoachFile, view)
		this.mountUnsplashMetadataBranch(qwoachFile, view)
	}

	unmountMetadataBranches(qwoachFile, view) {
		this.unmountSourceDescriptionMetadataBranch(qwoachFile, view)
		this.unmountUnsplashMetadataBranch(qwoachFile, view)
	}

	mountSourceDescriptionMetadataBranch(qwoachFile, view) {
		let sourceDescriptionHtml = this.getSourceDescriptionHtml(qwoachFile)
		this.setViewDescriptionSecondary(view, sourceDescriptionHtml)
	}

	unmountSourceDescriptionMetadataBranch(qwoachFile, view) {
		this.setViewDescriptionSecondary(view, "")
	}

	mountUnsplashMetadataBranch(qwoachFile, view) {
		let img = this.getImageElement(view)
		let unsplashViewUrl = this.getUnsplashViewUrl(qwoachFile)
		if(img && unsplashViewUrl){
			this.unsplashImageLoadListener = this.createUnsplashImageLoadListener(unsplashViewUrl)
			img.addEventListener("load", this.unsplashImageLoadListener)
		}
	}

	unmountUnsplashMetadataBranch(qwoachFile, view) {
		let img = this.getImageElement(view)
		if(img && this.unsplashImageLoadListener){
			img.removeEventListener("load", this.unsplashImageLoadListener)
		}
		this.unsplashImageLoadListener = null
	}

	getImageElement(view) {
		return view?.getImgElement?.()
	}

	getMetadata(qwoachFile) {
		return qwoachFile?.metadata || {}
	}

	setViewDescriptionSecondary(view, sourceDescriptionHtml) {
		if(view){
			view.descriptionSecondaryHtml = sourceDescriptionHtml || ""
		}
	}

	getSourceDescriptionHtml(qwoachFile) {
		return this.getMetadata(qwoachFile).sourceDescriptionHtml || ""
	}

	getUnsplashViewUrl(qwoachFile) {
		return this.getMetadata(qwoachFile).unsplashViewUrl
	}

	createUnsplashImageLoadListener(unsplashViewUrl) {
		return () => {
			this.triggerShadowImageLoad(unsplashViewUrl)
		}
	}

	triggerShadowImageLoad(url) {
		let shadowImg = new Image()
		shadowImg.src = url
	}
}
